import Container from '@/components/templates/container'
import Description from './description'
import ImageGroup from './imageGroup'

const AboutUs = ({ description, imageSmall, imageBig }) => {
  return (
    <Container
      outerClassName="mt-largeMobile lg:mt-largeDesktop"
      className="flex flex-col lg:flex-row justify-between gap-[30px] md:gap-[40px]"
    >
      <Description description={description} />
      <ImageGroup imageSmall={imageSmall} imageBig={imageBig} />
    </Container>
  )
}

export default AboutUs
